/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_BOT_NOTIFICATIONS_REQUEST,
  FETCH_BOT_NOTIFICATIONS_SUCCESS,
  FETCH_BOT_NOTIFICATIONS_FAILURE,
} from '../../constants/ActionTypes';

const main = (state = { isFetching: false, error: {} }, action) => {
  switch (action.type) {
    case FETCH_BOT_NOTIFICATIONS_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case FETCH_BOT_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
        data: action.data.data,
      };
    case FETCH_BOT_NOTIFICATIONS_FAILURE:
      return { ...state, isFetching: false, error: action.data };
    default:
      return state;
  }
};

const botNotifications = combineReducers({
  main,
});

export default botNotifications;
